import type { EditorSdkAdapter } from '@wix/bookings-adapter-editor-sdk';
import { type EditorSDK, EventType } from '@wix/platform-editor-sdk';
import { openManageBookings } from './backoffice-actions';

export enum EditorActions {
  openManageServices = 'openManageServices',
}

export const addEditorActionsListeners = (editorSDK: EditorSDK, editorSdkAdapter: EditorSdkAdapter, appToken: string) =>
  editorSDK.addEventListener(
    EventType.navBarMainActionClicked,
    async (event) => {
      const { actionId } = event.detail;

      if (actionId === EditorActions.openManageServices) {
        await openManageBookings(editorSdkAdapter, editorSDK, appToken);
      } else {
        console.warn('Editor Event handler: Unknown event:', event)
      }
    },
  )
  